import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Step } from "react-joyride";

export function useGuideTourSteps(): Step[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        target: '[data-tour="sidebar-nav"]',
        title: t("tour.sidebar.title"),
        content: t("tour.sidebar.content"),
        placement: "right" as const,
        skipBeacon: true,
        // TES-1659: keep target + tooltip fully in view on every guide step.
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="nav-dashboard"]',
        title: t("tour.dashboard.title"),
        content: t("tour.dashboard.content"),
        placement: "right" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="nav-tasks"]',
        title: t("tour.tasks.title"),
        content: t("tour.tasks.content"),
        placement: "right" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="nav-inspections"]',
        title: t("tour.inspections.title"),
        content: t("tour.inspections.content"),
        placement: "right" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="nav-defects"]',
        title: t("tour.defects.title"),
        content: t("tour.defects.content"),
        placement: "right" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="nav-teams"]',
        title: t("tour.teams.title"),
        content: t("tour.teams.content"),
        placement: "right" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="notification-bell"]',
        title: t("tour.notifications.title"),
        content: t("tour.notifications.content"),
        placement: "bottom" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        target: '[data-tour="help-button"]',
        title: t("tour.help.title"),
        content: t("tour.help.content"),
        placement: "right" as const,
        scrollOffset: 120,
        scrollDuration: 400,
      },
      {
        // TES-1659: top-placement → tooltip sits above target; extra headroom.
        target: '[data-tour="user-menu"]',
        title: t("tour.profile.title"),
        content: t("tour.profile.content"),
        placement: "top" as const,
        scrollOffset: 260,
        scrollDuration: 400,
      },
    ],
    [t],
  );
}
